export enum Path {
  Home = '/',
  Login = '/login',
  Profile = '/profile',
  ErrorPage = '/error',
  Document = '/document/:slug',
  PasswordRecover = '/password-recover',
  PasswordReset = '/reset-password',
  MailChangeStatus = '/mail-change-status',
  Invitation = `/register`,

  Performance = '/performance',
  Partners = '/partners',
  Partner = '/partners/:partnerId',
  AddPartner = '/partners/add',
  EditPartner = '/partners/:partnerId/edit',
  Hole = '/courses/:courseId/holes/:holeId',
  Courses = '/courses',
  SearchCourse = `${Path.Courses}/add`,
  AddCourse = `${Path.Courses}/add/:idCourse`,
  Course = '/courses/:courseId',
  EditCourse = '/courses/:courseId/edit',
  DrivingRangeSetup = '/courses/:courseId/driving-range/setup',
  Devices = '/devices',
  Device = '/devices/:deviceId',
  Gameplay = '/gameplay',
  GameInfo = '/gameplay/:gameId',
  Players = '/players',
  Player = '/players/:playerId',
  Users = '/users',
  User = '/users/:userId',
  Coupons = '/coupons',
  CouponsList = '/coupons/list',
  AddCoupon = '/coupons/add',
  Coupon = '/coupons/:couponId',
  EditCoupon = '/coupons/:couponId/edit',
  DeactivateCoupon = '/coupons/:couponId/deactivate',
  ActivateCoupon = '/coupons/:couponId/activate',
}

export enum NavBarLinks {
  Performance = Path.Performance,
  Partners = Path.Partners,
  Courses = Path.Courses,
  Devices = Path.Devices,
  Gameplay = Path.Gameplay,
  Players = Path.Players,
  Users = Path.Users,
  Coupons = Path.Coupons,
}
